import React, { FC, useCallback, useEffect, useRef, useState, useContext } from 'react';
import {
    IState
} from "../types/types";
import { get, post } from "../fetchers/fetchers";
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import AddIcon from '@material-ui/icons/Add';
import DialogContentText from '@material-ui/core/DialogContentText';
import { TasksDispatchContext, useTask } from '../stateManagement/context';
import {
    Button,
    Dialog, DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    IconButton,
    TableRow,
    TextField, TextFieldProps,
    Tooltip,
    withStyles
} from "@material-ui/core";
import Assessment from "./assessment";
import { useParams } from "react-router";

import ProjectFailureModes from "./project_failure_modes";
import Documents from "./documents";
import { getStates } from '../stateManagement/data';
import { API_URL } from "../env";
interface IStatesProps {
    closeDialogCallback: (reload: boolean) => void;
}

interface IRouteParams {
    id: string
}



const States: FC<IStatesProps> = ({
    closeDialogCallback
}) => {

    let dispatch = useContext(TasksDispatchContext)
    let tasks = useTask()

    const [states, setStates] = useState<IState[]>([]);

    const [openCreateDialog, setOpenCreateDialog] = useState<boolean>(false);
    const newState = useRef<TextFieldProps>(null);

    const [currentState, setCurrentState] = useState<IState>();

    const params = useParams<IRouteParams>()


    const handleClose = () => {
        setOpenCreateDialog(false)
    }

    const handleOpen = () => {
        setOpenCreateDialog(true)
    }

    const handleAddState = () => {
        if (!currentState) {
            throw new Error("Current Failure Mode needs to be set")
        }

        addState(currentState).then(() => setOpenCreateDialog(false))
    }


    const addState = async (f: IState) => {
        let fm = { ...f }
        delete fm.id;


        await post<IState>(API_URL + "states/", fm);

        getStates(params.id, dispatch)

    }

    useEffect(() => {

        if (tasks.loaded) {

            setStates(tasks.states)

        }

    })


    return (
        <>


            <Dialog open={true} onClose={closeDialogCallback} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">States</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <Typography>
                            Project States
                        </Typography>
                        {
                            states.map((s, i) => {
                                return (
                                    <li>
                                        {s.name}
                                    </li>
                                )
                            })
                        }

                        <IconButton color="primary" component="span"
                            style={{
                                margin: "auto",
                                backgroundColor: "rgb(84,107,213)",
                                color: "rgb(255,255,255)"
                            }} onClick={() => {
                                setCurrentState({ uuid: -1, name: "", assessment_project_id: parseInt(params.id) })
                                handleOpen()
                            }
                            }>
                            <AddIcon fontSize="small" />
                        </IconButton>

                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={_ => closeDialogCallback(false)} color="primary">
                        Cancel
                    </Button>

                </DialogActions>
            </Dialog>

            <Dialog open={openCreateDialog} onClose={handleClose} aria-labelledby="form-dialog-title" fullWidth>
                <DialogTitle id="form-dialog-title">State</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Create State
                    </DialogContentText>

                    <TextField
                        fullWidth
                        label="State"
                        value={currentState?.name}
                        onChange={(event) => {
                            let v = (event.target.value as string);

                            let c = { ...currentState } as IState
                            c.name = v


                            setCurrentState(c)
                        }} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleAddState} color="primary">
                        Submit
                    </Button>
                </DialogActions>
            </Dialog>


        </>
    );
};

export default States;

